module.exports = __webpack_public_path__ + "img/logo.caa77622.png";